const MEDIA_BASE = process.env.REACT_APP_MEDIA_URL || '';

export function resolveMediaUrl(path) {
  if (!path) {
    return '';
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${MEDIA_BASE}${normalized}`;
}
